/* unplugin-vue-components disabled */import script from "./reserveShose.vue?vue&type=script&setup=true&lang=ts"
export * from "./reserveShose.vue?vue&type=script&setup=true&lang=ts"

import "./reserveShose.vue?vue&type=style&index=0&id=723e416a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-723e416a"]])

export default __exports__